export const EVENT_STATUS = {
  VISIBLE: 8,
  HIDDEN: 9
};

// Supports both single-building (status) and multi-building (status_id, visible) APIs.
export const getEventStatus = (event) => event?.status_id ?? event?.status;

export const isEventVisible = (event) => {
  const row = event?.buildings?.find((b) => b.building_id === event.building_id);
  const visible = row ? row.visible : event?.visible;
  return getEventStatus(event) === EVENT_STATUS.VISIBLE && visible !== false;
};

export const EVENT_STATUS_LABEL = {
  [EVENT_STATUS.VISIBLE]: 'Visible',
  [EVENT_STATUS.HIDDEN]: 'Hidden'
};

export const EVENT_IMAGE_TYPE = {
  BANNER: 'banner',
  THUMBNAIL: 'thumbnail'
};
